export const yearKeyLabel = {
  key: 'year',
  label: 'Year'
};

export const facilityKeyLabel = {
  key: 'facility',
  label: 'Facility'
};

export const documentUrlKeyLabel = {
  key: 'documentUrl',
  label: 'Bill / Supporting Document',
  tableColumnLabel: 'Attached Document'
};

export const stackholderKeyLabel = {
  key: 'StackholderType',
  label: 'Stackholder Type'
};
export const roleKeyLabel = {key: 'Role', label: 'Role'};
export const accessKeyLabel = {key: 'Access', label: 'Access'};
export const permissionKeyLabel = {
  key: 'selectedPermissions',
  label: 'Modules & Permissions'
};
